
const contents = "query HomeNetworkRedirect($resourceId: ID) {\n  viewer {\n    homeNetworkRedirect(resourceId: $resourceId) {\n      networkPermalink\n      redirectResourceId\n      shouldRedirectToHomeNetwork\n    }\n  }\n}";
const sha256Hash = "1c481b603aa4a3671ab46a25f951c87241ef3204a22ec6c3f3fa73d7e1c2c863";
export default { contents: contents, sha256Hash: sha256Hash };
